/**
 * The medal cabinet.
 *
 * Unearned medals are shown, not hidden: greyed, with a dashed ring and a
 * subtitle that reads as an invitation ("Not run yet") rather than an error.
 */

// medals: array of { t: title, s: subtitle, on: earned, tone: 'g' | 's' | 'b' }

/* The metallic ring finishes — gold, silver, bronze — plus the locked state. */
const RING_TONE = {
  g: 'bg-gradient-to-br from-[#F0C24B] to-[#B98708] shadow-[0_4px_12px_rgba(212,160,23,.35)]',
  s: 'bg-gradient-to-br from-[#C3CCD9] to-[#7E8A9C]',
  b: 'bg-gradient-to-br from-[#D28A4C] to-[#94531F]',
};
const RING_LOCKED = 'border-2 border-dashed border-line-strong bg-line-chip text-copy-label';

export function MedalCabinet({ medals }) {
  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(140px,1fr))] gap-2.5">
      {medals.map((m) => (
        <div
          key={m.t}
          className={`border border-line bg-white px-3 py-4 text-center ${
            m.on ? '' : 'bg-ground opacity-55'
          }`}
        >
          <div
            className={`mx-auto mb-2.5 grid h-[52px] w-[52px] place-items-center rounded-full font-market text-base font-extrabold text-white ${
              m.on ? RING_TONE[m.tone] ?? RING_TONE.b : RING_LOCKED
            }`}
            aria-hidden="true"
          >
            {m.on ? '★' : '○'}
          </div>
          <div className="font-market text-sm font-bold uppercase tracking-[0.03em]">{m.t}</div>
          <div className="mt-1 font-market text-[9.5px] leading-snug text-copy-muted">{m.s}</div>
        </div>
      ))}
    </div>
  );
}
